import { RequestConfig } from '../types';

interface IReturn {
  message: string;
  responseStatus: number;
  errorData: unknown;
}

export async function handleHttpError(
  response: Response,
  config: RequestConfig,
  notifyError?: (message: string) => void,
  onPaymentRequired?: () => void
): Promise<IReturn> {
  const contentType = response.headers.get('content-type');

  let message = `HTTP ${response.status}`;
  let errorData: unknown;

  try {
    if (contentType?.includes('application/json')) {
      errorData = await response.json();

      message =
        (errorData as any)?.message || (errorData as any)?.detail || message;
    } else {
      message = await response.text();
    }
  } catch {}

  if (response.status === 403) {
    notifyError?.('У вас нет прав доступа!');
  } else if (response.status === 402) {
    notifyError?.(message);
    onPaymentRequired?.();
  } else if (config.notify?.error) {
    notifyError?.(message);
  }

  return { message, responseStatus: response.status, errorData };
}
